export default {
  typeOptions: {
    NP: 'Persona física',
    LP: 'Persona jurídica'
  },
  NP: {
    type: 'Personalidad jurídica',
    residence: 'Tipo de residencia',
    name: 'Nombre',
    tradeName: 'Primer Apellido',
    lastName: 'Segundo Apellido',
    document: 'CIF',
    street: 'Dirección',
    postalCode: 'Código Postal',
    town: 'Población',
    city: 'Provincia',
    country: 'País',
    accountingOffice: 'Oficina Contable',
    Dir3Data: {
      code: 'Código',
      description: 'Descripción',
      postalCode: 'Código Postal',
      address: 'Direccion',
      city: 'Ciudad',
      region: 'Provincia',
      country: 'País',
      name: 'Nombre',
      firstName: 'Primer Apellido',
      lastName: 'Segundo Apellido'
    },
    managerBody: 'Cod órgano gestor',
    processingUnit: 'Unidad tramitadora',
    proponentBody: 'Órgano proponente',
    contactMedium: 'Datos de contacto',
    additionalInfo: 'Información adicional reclamada por el pagador',
    contractReference: 'Referencia de contrato',
    mercantileRegistry: 'Registro Mercantil'
  },
  LP: {
    type: 'Personalidad jurídica',
    residence: 'Tipo de residencia',
    name: 'Razón social',
    tradeName: 'Nombre comercial',
    lastName: 'Segundo Apellido',
    document: 'CIF',
    street: 'Dirección',
    postalCode: 'Código Postal',
    town: 'Población',
    city: 'Provincia',
    country: 'País',
    accountingOffice: 'Oficina Contable',
    managerBody: 'Cod. órgano gestor',
    processingUnit: 'Unidad tramitadora',
    proponentBody: 'Órgano proponente',
    contactMedium: 'Datos de contacto',
    additionalInfo: 'Información adicional reclamada por el pagador',
    contractReference: 'Referencia de contrato',
    mercantileRegistry: 'Registro Mercantil',
    FACeB2B: {
      sectionTitle: 'Datos FACeB2B',
      code: 'Código del receptor',
      name: 'Nombre',
      publicOrganismCode: 'Órgano gestor',
      contractReference: 'Referencia del contrato'
    }
  },
  FC: {
    residence: 'Tipo de residencia',
    corporateName: 'Razón social',
    tradeName: 'Nombre comercial',
    document: 'CIF',
    address: 'Dirección',
    street: 'Calle',
    postalCode: 'Código Postal',
    town: 'Población',
    city: 'Provincia',
    country: 'País',
    book: 'Libro',
    folio: 'Folio',
    sheet: 'Hoja',
    section: 'Sección',
    volume: 'Volumen',
    mercantileRegistry: 'Registro Mercantil',
    additionalRegistrationData: 'Información adicional',
    medium: 'Información adicional',
    email: 'Email',
    fax: 'Fax',
    phone: 'Teléfono',
    web: 'Dirección web',
    name: 'Persona de contacto',
    additionalContactDetails: 'Información adicional'
  },
  riojaAgendaMessage: 'Se recomienda añadir el contacto desde la agenda y realizando la búsqueda por el Órgano gestor, en lugar de añadirlo manualmente'
}
